import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'info',
    template: require('./info.component.html')
})

export class InfoComponent {

    constructor(public router: Router) {
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/front/info/info.component.ts
 **/